// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"62f2f8ff","453":"dd7d721d","508":"116c9687","776":"3e7dc1fd"}[chunkId] + ".chunk.js";
};